<template>
  <div class="card" :class="`card--${background}`">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    background: {
      type: String,
      default: 'white'
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  padding: 16px;
  box-shadow: 0 4px 20px rgba($mine-shaft, 0.05);
  border-radius: 16px;

  &--white {
    background: $white;
  }
}
</style>
